import { StyleSheet, Text, View } from 'react-native'
import React from 'react'

export const PlayerTimes = () => {
  return (
    <View>
      <Text>PlayerTimes</Text>
    </View>
  )
}



const styles = StyleSheet.create({})